module.exports = __webpack_public_path__ + "static/smartpay_21-curbside-ac86020ee1a514b7849316418e6389ee.svg";